const CONFIG = {
  DRAFT:            { dot: "bg-slate-400",   bg: "bg-slate-100",   text: "text-slate-600",   border: "border-slate-200"  },
  OPEN:             { dot: "bg-sky-500",      bg: "bg-sky-50",      text: "text-sky-700",     border: "border-sky-200"    },
  SUBMITTED:        { dot: "bg-amber-500",    bg: "bg-amber-50",    text: "text-amber-700",   border: "border-amber-200"  },
  PENDING_APPROVAL: { dot: "bg-amber-500",    bg: "bg-amber-50",    text: "text-amber-700",   border: "border-amber-200"  },
  SUB_APPROVED:     { dot: "bg-teal-500",     bg: "bg-teal-50",     text: "text-teal-700",    border: "border-teal-200"   },
  APPROVED:         { dot: "bg-emerald-500",  bg: "bg-emerald-50",  text: "text-emerald-700", border: "border-emerald-200"},
  REJECTED:         { dot: "bg-red-500",      bg: "bg-red-50",      text: "text-red-700",     border: "border-red-200"    },
  CANCELLED:        { dot: "bg-slate-400",    bg: "bg-slate-100",   text: "text-slate-500",   border: "border-slate-200"  },
  DELETED:          { dot: "bg-slate-400",    bg: "bg-slate-100",   text: "text-slate-500",   border: "border-slate-200"  },
  CLOSED:           { dot: "bg-slate-400",    bg: "bg-slate-100",   text: "text-slate-600",   border: "border-slate-200"  },
  POSTED:           { dot: "bg-emerald-500",  bg: "bg-emerald-50",  text: "text-emerald-700", border: "border-emerald-200"},
  VOID:             { dot: "bg-slate-300",    bg: "bg-slate-100",   text: "text-slate-500",   border: "border-slate-200"  },
  NOT_STARTED:      { dot: "bg-slate-400",    bg: "bg-slate-100",   text: "text-slate-600",   border: "border-slate-200"  },
  IN_PROGRESS:      { dot: "bg-blue-500",     bg: "bg-blue-50",     text: "text-blue-700",    border: "border-blue-200"   },
  COMPLETED:        { dot: "bg-[#910029]",   bg: "bg-[#F5E6EC]",   text: "text-[#910029]",   border: "border-[#D4A0B0]"  },
  DELAYED:          { dot: "bg-red-500",      bg: "bg-red-50",      text: "text-red-700",     border: "border-red-200"    },
  BLOCKED:          { dot: "bg-red-500",      bg: "bg-red-50",      text: "text-red-700",     border: "border-red-200"    },
  ACKNOWLEDGED:     { dot: "bg-amber-500",    bg: "bg-amber-50",    text: "text-amber-700",   border: "border-amber-200"  },
  RESOLVED:         { dot: "bg-emerald-500",  bg: "bg-emerald-50",  text: "text-emerald-700", border: "border-emerald-200"},
  LOW:              { dot: "bg-slate-400",    bg: "bg-slate-100",   text: "text-slate-600",   border: "border-slate-200"  },
  MEDIUM:           { dot: "bg-sky-500",      bg: "bg-sky-50",      text: "text-sky-700",     border: "border-sky-200"    },
  HIGH:             { dot: "bg-amber-500",    bg: "bg-amber-50",    text: "text-amber-700",   border: "border-amber-200"  },
  CRITICAL:         { dot: "bg-red-500",      bg: "bg-red-50",      text: "text-red-700",     border: "border-red-200"    },
  PASS:             { dot: "bg-emerald-500",  bg: "bg-emerald-50",  text: "text-emerald-700", border: "border-emerald-200"},
  FAIL:             { dot: "bg-red-500",      bg: "bg-red-50",      text: "text-red-700",     border: "border-red-200"    },
  OPTIONAL:         { dot: "bg-slate-400",    bg: "bg-slate-100",   text: "text-slate-600",   border: "border-slate-200"  },
  NOTED_FOR_INFORMATION: { dot: "bg-sky-500", bg: "bg-sky-50",      text: "text-sky-700",     border: "border-sky-200"    },
  UNDER_EPC:        { dot: "bg-amber-500",    bg: "bg-amber-50",    text: "text-amber-700",   border: "border-amber-200"  },
  UNDER_OE:         { dot: "bg-amber-500",    bg: "bg-amber-50",    text: "text-amber-700",   border: "border-amber-200"  },
  ACTIVE:           { dot: "bg-emerald-500",  bg: "bg-emerald-50",  text: "text-emerald-700", border: "border-emerald-200"},
  INACTIVE:         { dot: "bg-slate-400",    bg: "bg-slate-100",   text: "text-slate-500",   border: "border-slate-200"  },
  SENT:             { dot: "bg-emerald-500",  bg: "bg-emerald-50",  text: "text-emerald-700", border: "border-emerald-200"},
  CONVERTED:        { dot: "bg-violet-500",   bg: "bg-violet-50",   text: "text-violet-700",  border: "border-violet-200" },
  PARTIALLY_RECEIVED: { dot: "bg-blue-500",   bg: "bg-blue-50",     text: "text-blue-700",    border: "border-blue-200"   },
};

const FALLBACK = { dot: "bg-slate-400", bg: "bg-slate-100", text: "text-slate-600", border: "border-slate-200" };

const LABEL_MAP = {
  SUBMITTED: "Pending Approval",
  DELETED: "Deleted",
  SUB_APPROVED: "Sub-Approved",
  NOT_STARTED: "Not Started",
  IN_PROGRESS: "In Progress",
  NOTED_FOR_INFORMATION: "For Info",
  UNDER_EPC: "Under EPC",
  UNDER_OE: "Under OE",
  PARTIALLY_RECEIVED: "Partial",
};

export function StatusPill({ value, testId }) {
  if (!value) return <span className="text-xs text-muted-foreground">—</span>;
  const c = CONFIG[value] || FALLBACK;
  const label = LABEL_MAP[value] || String(value).replaceAll("_", " ");
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${c.bg} ${c.text} ${c.border}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot} flex-shrink-0`} />
      {label}
    </span>
  );
}
